import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";
//import colors from "../../colors";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }
 

  render() {
    return (
      <div
      className=" cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: "#f0f5ff",
        }}
      >
          <Slider />

          <div style={{ padding: "10px" }}>
            <MDBCard style={{ width: "100%", textAlign: "justify" }}>
              <MDBCardBody>
                <MDBCardTitle style={{ color: "blue" }}>
                  Hydrological drought
                </MDBCardTitle>
                {/* <h5>More Information</h5> */}
                <MDBCardText>
                  Hydrological drought is associated with the effects of periods
                  of precipitation (including snowfall) shortfalls on surface or
                  subsurface water supply (i.e., stream-flow, reservoir and lake
                  levels, groundwater). Although all droughts originate with a
                  deficiency of precipitation, hydrologists are more concerned
                  with how this deficiency plays out through the hydrologic
                  system. Hydrological droughts are usually out of phase with or
                  lag the occurrence of meteorological and agricultural
                  droughts. It takes longer for precipitation deficiencies to
                  show up in components of the hydrological system such as
                  stream-flow, and groundwater and surface water storages. This
                  portal provides the information on Hydrological drought
                  accounting for all the above mentioned factors in the form of
                  multiple indices including a comprehensive index known as
                  composite Hydrological Drought Index.
                </MDBCardText>

                {/* </MDBCardText> */}
                {/* <div style={{align:"right"}}><h6 >Read More</h6></div> */}
              </MDBCardBody>
            </MDBCard>
          </div>
          <HomeCardDeck />
        </div>
      </div>
    );
  }
}

export default Home;
